import Caption from '../ui/Typo/Caption'

interface Props {
  ns1: string
  ns2: string
  setNs1: (s: string) => void
  setNs2: (s: string) => void
}

const InputNsSection: React.FC<Props> = ({ ns1, ns2, setNs1, setNs2 }) => {
  return (
    <div className="w-full h-40 mt-4 text-center">
      <Caption weight="font-semibold">
        NS1:
        <span>
          <input
            value={ns1}
            onChange={(e) => setNs1(e.target.value)}
            placeholder="Enter NS1:"
            className="w-full px-4 py-2 font-light border rounded outline-secondary"
            type="text"
          />
        </span>
      </Caption>
      <Caption weight="font-semibold" className="mt-3">
        NS2:
        <span>
          <input
            value={ns2}
            onChange={(e) => setNs2(e.target.value)}
            placeholder="Enter NS2:"
            className="w-full px-4 py-2 font-light border rounded outline-secondary"
            type="text"
          />
        </span>
      </Caption>
    </div>
  )
}

export default InputNsSection
